import React, { useMemo } from 'react';
import { connect, FormikContextType } from 'formik';
import { VideoFormProps } from './VideoFormModel';
import { FormContent } from 'components/common/form/Form';
import { useVideoFormConfig } from './useVideoFormConfig';
import i18n from 'i18n';

export const VideoForm: React.FunctionComponent<
  VideoFormProps & { formik: FormikContextType<any> }
> = (props) => {
  const { values } = props.formik;
  const videoSrc = values.typeProperties.videoSrc;
  const isThirdPartyVideo = videoSrc === '3rd';
  const isEditing = values.creativeId !== undefined;
  const skippableSetting = values.typeProperties.skippableSetting;
  const skippable = skippableSetting.skippable;

  const validateTenMaxVideo = props.model.validateTenMaxVideo;

  const hints = useMemo(
    () => [
      i18n.t('creativeSetupFlow.labels.videoTypeHint'),
      i18n.t('creativeSetupFlow.labels.storageHint', {
        storage: '500MB'
      }),
      i18n.t('creativeSetupFlow.labels.videoDurationHint')
    ],
    []
  );

  const formConfig = useVideoFormConfig(
    props.basicFields,
    isEditing,
    isThirdPartyVideo,
    skippable,
    hints,
    validateTenMaxVideo,
    props.getInitFormConfig
  );

  return <FormContent formConfig={formConfig} />;
};

export default connect(VideoForm);
